<template>
    <ModalDefault :overlay="false" @close="closeModal" :loading="loading || parentLoading">
        <template slot="main">
            <h1 class="title text-center">{{ $trad.userList.title }} {{ getZone.name }}</h1>

            <div class="table-responsive mt-5">
                <table class="table table-stripped">
                    <tr v-for="user in usersFiltered">
                        <td>
                            <router-link tag="a" :to="'/users/user/' + user.id" v-if="hasAccessSuperAdmin() || currentBrand.id === user.brandId">
                                <LinkToUserIcon style="width: 20px; height: 20px" />
                            </router-link>
                        </td>
                        <td>
                            <a class="mailto" :href="'mailto:' + user.email">{{ user.lastname | capitalize }} {{ user.firstname | capitalize }}</a>
                        </td>
                        <td>{{ user.profile ? user.profile : "" }}</td>
                        <td>{{ brands.find(b => b.id === user.brandId).name | capitalize }}</td>
                    </tr>
                </table>
            </div>
        </template>
    </ModalDefault>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import CheckBox from "@/components/ui/CheckBox";
import RadioInput from "@/components/ui/RadioInput";
import Multiselect from "vue-multiselect";
import TryLoad from "@/mixins/TryLoadMixin";
import ModalTheme from "@/components/ui/ModalTheme";
import userService from "@/services/user";
import cacheService from "@/services/cache";
import LinkToUserIcon from "@/components/forecasts/elements/icons/LinkToUserIcon";
import ModalDefault from "@/components/ui/ModalDefault";

export default {
    data: () => ({
        zone: {},
        users: [],
        zoneSelected: null,
        copyWithPrice: true,
        currentBrandId: cacheService.getCurrentBrandId(),
        brands: cacheService.getBrands()
    }),
    components: {
        ModalDefault,
        CheckBox,
        RadioInput,
        Multiselect,
        ModalTheme,
        LinkToUserIcon
    },
    mixins: [TryLoad],
    props: {
        parentLoading: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    watch: {},
    mounted() {},
    methods: {
        closeModal() {
            this.$emit("cancel");
        }
    },
    computed: {
        ...mapGetters({
            getZone: "items/getZone"
        }),
        ...mapState("currentUser", ["currentBrand"]),
        usersFiltered() {
            return this.users.filter(u => this.brands.some(b => b.id === u.brandId));
        }
    },
    async created() {
        this.users = await this.tryLoad(() => userService.getUsersByZone(this.getZone.id));
    }
};
</script>
<style lang="scss" scoped>
.title {
    font-size: 32px;
    font-family: "Oswald", sans-serif;
}
.mailto {
    color: #000;
    font-weight: bold;
    text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// ShowUsers.vue?da9f949e